import { Component } from 'react';
import { Button } from './ui/button';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('ErrorBoundary caught', error, info);
  }

  reset = () => {
    this.setState({ hasError: false, error: null });
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-[400px] flex items-center justify-center p-6" data-testid="error-boundary-fallback">
          <div className="max-w-md text-center bg-white rounded-lg border border-red-200 p-8 shadow-sm">
            <AlertTriangle className="w-10 h-10 text-red-500 mx-auto mb-4" />
            <h2 className="text-lg font-semibold text-[#0A2342] mb-2">Something went wrong on this screen</h2>
            <p className="text-sm text-gray-600 mb-4">
              {this.state.error?.message || 'An unexpected error occurred. Your data is safe.'}
            </p>
            <div className="flex gap-2 justify-center">
              <Button onClick={this.reset} variant="outline" data-testid="error-boundary-retry">Try again</Button>
              <Button onClick={() => window.location.reload()} className="bg-[#0A2342] text-white hover:bg-[#0A2342]/90" data-testid="error-boundary-reload">Reload page</Button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
